import { Audience } from '@dadohr/shared/domainTypes/experience';
import { Tooltip, Typography } from '@material-ui/core';
import { useUnsafeTranslation } from '../../../../../i18next';

export const AudienceHint = ({
  type,
  audience
}: {
  type: 'task' | 'message' | 'automation';
  audience: Audience | null | undefined;
}) => {
  const { t } = useUnsafeTranslation();
  if (!audience?.name) {
    return null;
  }
  const tooltip = t('This {{ type }} uses the "{{ audience }}" audience', {
    type: t(type),
    audience: audience.name
  });
  return (
    <Tooltip title={tooltip}>
      <Typography variant="caption">{audience.name}</Typography>
    </Tooltip>
  );
};
